/*
* @Author: zhangzhitao
* @Date: 2019-06-01 14:07:51
* @Des:
 * @Last Modified by: zhangzhitao
 * @Last Modified time: 2019-06-01 16:39:21
*/

<template>
  <div class="m-wiget-store-filter">
    <ul class="m-type-tags">
      <li
        :class="{'is-active':typeTag==='widget'}"
        @click="$emit('typeTag','widget')"
      >{{ $t("management.home.widget_label") }}</li>
      <li
        :class="{'is-active':typeTag==='model'}"
        @click="$emit('typeTag','model')"
      >{{ $t("management.home.moudle_label") }}</li>
    </ul>
    <ul class="m-widget-types">
      <li
        :class="{ 'is-active': activeWidgetClassify === classify.code }"
        v-for="classify in widgetClassify"
        :key="classify.code"
        @click="handleWidgetClassify(classify.code)"
      >{{classify.name}}</li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'widget-store-filter',
  props: {
    typeTag: {
      type: String,
      default: 'widget'
    },
    activeWidgetClassify: {
      type: String,
      default: 'all'
    }
  },
  data () {
    return {
      widgetClassify: [{ code: 'all', name: this.$t('management.home.nav_all_label') }, { code: 'navigation', name: this.$t('management.home.nav_nav_label') }, { code: 'chart', name: this.$t('management.home.nav_charts_label') }, { code: 'image', name: this.$t('management.home.nav_carousel_label') }, { code: 'page', name: this.$t('management.home.nav_inset_label') }, { code: 'table', name: this.$t('management.home.nav_list_label') }, { code: 'todo', name: this.$t('common.widget_type7') }],
      realType: 'widget'
    }
  },

  methods: {
    // 部件类型选择
    handleWidgetClassify (code) {
      this.$emit('classify', code)
    }
  }
}

</script>

<style lang="scss" scoped>
.m-wiget-store-filter {
  width: 100%;
  height: 48px;
  box-sizing: border-box;
  padding: 8px 0;
  .m-type-tags {
    float: left;
    li {
      display: inline-block;
      padding: 0 20px;
      color: rgba(0, 0, 0, 0.4);
      line-height: 32px;
      cursor: pointer;
      &.is-active {
        background: #ebebeb;
        color: rgba(0, 0, 0, 0.7);
        font-weight: 700;
      }
      &:hover {
        color: rgba(0, 0, 0, 0.7);
      }
    }
  }
  .m-widget-types {
    float: right;
    li {
      display: inline-block;
      padding: 0 20px;
      line-height: 32px;
      color: rgba(0, 0, 0, 0.4);
      cursor: pointer;
      &.is-active {
        color: rgba(0, 0, 0, 0.7);
      }
      &:hover {
        color: rgba(0, 0, 0, 0.7);
      }
    }
  }
}
</style>
